import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { PostItem } from '@/models/features/posts.models'

import { authAPI } from '../new-api'

export type GetPostByIdRequest = {
  groupId?: number
  postId?: number
}

export const GET_POSTS_BY_ID_QUERY_KEY = 'useGetPostById'
export const getPostByIdQueryKey = (data: GetPostByIdRequest) => [GET_POSTS_BY_ID_QUERY_KEY, data]

export const getPostById = async (data: GetPostByIdRequest, signal?: AbortSignal) => {
  const { groupId, postId } = data
  const response = await authAPI.get<PostItem>(`/group/${groupId}/post/${postId}`, {
    signal,
  })

  return response.data
}

export const useGetPostById = (data: GetPostByIdRequest) => {
  return useQuery({
    enabled: !!data.groupId && !!data.postId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPostById(data, signal),
    queryKey: getPostByIdQueryKey(data),
  })
}
